export default "__VITE_ASSET__CMhVVMgx__"